export default {
    MAX_ATTACHMENT_SIZE: 5000000,
    OUTH_DOMAIN_URL: process.env.REACT_APP_OUTH_URL,
    SOCIAL_SIGN_IN_REDIRECT_URL: process.env.REACT_APP_WEB_URL+"/login",
    SOCIAL_SIGN_OUT_REDIRECT_URL: process.env.REACT_APP_WEB_URL+"/",
    s3: {
        REGION: process.env.REACT_APP_REGION,
        BUCKET: process.env.REACT_APP_BUCKET_NAME
    },
    apiGateway: {
        REGION: process.env.REACT_APP_REGION,
        URL: process.env.REACT_APP_API_URL,
        ACTIVITY_URL: process.env.REACT_APP_ACTIVITY_API_URL,
        JOB_URL: process.env.REACT_APP_JOB_API_URL,
        BLOG_URL: process.env.REACT_APP_BLOG_API_URL,
        ROLE_URL: process.env.REACT_APP_ROLE_API_URL
    },
    cognito: {
        REGION: process.env.REACT_APP_REGION,
        USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
        APP_CLIENT_ID: process.env.REACT_APP_APP_CLIENT_ID,
        IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID
    },
    Storage: {
        AWSS3: {
            bucket: process.env.REACT_APP_BUCKET_NAME,
            region: process.env.REACT_APP_REGION,
        }
    }
};  